// Import core lib dependencies.
import { createSelector } from 'reselect';

// Config.
import Config			  from './config/config.js';

/**
 * <pre>
 * Goal module Selectors(s).
 *
 * Summary of responsibilities:
 *
 *  - defines reusable selectors to retrieve state properties
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Goal
 * @namespace
 *
 * @type {Object}
 */
const Selectors = {};

/**
 * Selector to access state property of Redux state for this module.
 *
 * @memberof module:Goal.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @param  {String}  id 	The module id.
 * @return {Object}  The value of the retrieved state property.
 */
const stateSelector = (state, id) => state[Config.stateKey][id].state;
Selectors.getState = createSelector(
	[stateSelector],
	(stateVal) => {
		return stateVal;
	}
);

/**
 * Selector to access progress property of Redux state for this module.
 *
 * @memberof module:Goal.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @param  {String}  id 	The module id.
 * @return {Object}  The value of the retrieved state property.
 */
const progressSelector = (state, id) => state[Config.stateKey][id].progress;
Selectors.getProgress = createSelector(
	[progressSelector],
	(progressVal) => {
		return progressVal;
	}
);

/**
 * Selector to access intervals property of Redux state for this module.
 *
 * @memberof module:Goal.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @param  {String}  id 	The module id.
 * @return {Object}  The value of the retrieved state property.
 */
const intervalsSelector = (state, id) => state[Config.stateKey][id].intervals;
Selectors.getIntervals = createSelector(
	[intervalsSelector],
	(intervalsVal) => {
		return intervalsVal;
	}
);

/**
 * Selector to access showConfirmation property of Redux state for this module.
 *
 * @memberof module:Goal.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @param  {String}  id 	The module id.
 * @return {Object}  The value of the retrieved state property.
 */
const showConfirmationSelector = (state, id) => state[Config.stateKey][id].showConfirmation;
Selectors.getShowConfirmation = createSelector(
	[showConfirmationSelector],
	(showConfirmationVal) => {
		return showConfirmationVal;
	}
);

/**
 * Selector to access showError property of Redux state for this module.
 *
 * @memberof module:Goal.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @param  {String}  id 	The module id.
 * @return {Object}  The value of the retrieved state property.
 */
const showErrorSelector = (state, id) => state[Config.stateKey][id].showError;
Selectors.getShowError = createSelector(
	[showErrorSelector],
	(showErrorVal) => {
		return showErrorVal;
	}
);

/**
 * Selector to access errorMessage property of Redux state for this module.
 *
 * @memberof module:Goal.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @param  {String}  id 	The module id.
 * @return {Object}  The value of the retrieved state property.
 */
const errorMessageSelector = (state, id) => state[Config.stateKey][id].errorMessage;
Selectors.getErrorMessage = createSelector(
	[errorMessageSelector],
	(errorMessageVal) => {
		return errorMessageVal;
	}
);

/**
 * Selector to access showCaptcha property of Redux state for this module.
 *
 * @memberof module:Goal.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @param  {String}  id 	The module id.
 * @return {Object}  The value of the retrieved state property.
 */
const showCaptchaSelector = (state, id) => state[Config.stateKey][id].showCaptcha;
Selectors.getShowCaptcha = createSelector(
	[showCaptchaSelector],
	(showCaptchaVal) => {
		return showCaptchaVal;
	}
);

export default Selectors;